<div>
  @if (anzahlSeiten() > 1) {
    <nav
      class="now-pagination m-0"
      attr.aria-label="Pagination Ergebnisliste ({{ position }})"
      tabindex="-1"
    >
      <ul>
        <!-- Zur Seite 1 Mobile -->
        <li class="now-page-first" id="page-first-{{ position }}-{{ idSuffix }}">
          <a
            href="#"
            [class.disabled]="isFirstPage"
            [attr.aria-disabled]="isFirstPage"
            [tabindex]="isFirstPage ? -1 : 0"
            aria-label="Erste Seite"
            title="Erste Seite"
            (click)="pageFirstClicked($event)"
          ></a>
        </li>

        <!-- Vorherige Seite -->
        <li
          class="now-page-previous disabled"
          [class.disabled]="isFirstPage"
          [attr.aria-disabled]="isFirstPage"
          id="page-previous-arrow-{{ position }}-{{ idSuffix }}"
        >
          <a
            href="#"
            [tabindex]="isFirstPage ? -1 : 0"
            [attr.aria-label]="labelVorherigeSeite"
            [title]="labelVorherigeSeite"
            (click)="pagePrevClicked($event)"
          ></a>
        </li>

        <!-- Zur Seite 1 -->
        @if (!isFirstPage && !isSecondFirstPage) {
          <li id="page-first-number-{{ position }}-{{ idSuffix }}">
            <a
              href="#"
              [tabindex]="isFirstPage ? -1 : 0"
              aria-label="Erste Seite"
              title="Erste Seite"
              (click)="pageFirstClicked($event)"
              >1</a
            >
          </li>
        }

        <!-- Drei Punkte Zurück Button -->
        @if (isThreePagesPrevious) {
          <li
            class="now-page-previous-group"
            id="page-previous-three-{{ position }}-{{ idSuffix }}"
          >
            <a
              href="#"
              [tabindex]="isFirstPage ? -1 : 0"
              aria-label="Drei Seiten zurück"
              title="Drei Seiten zurück"
              (click)="pageThreePagesPreviousClicked($event)"
              >...</a
            >
          </li>
        }

        <!-- numbers -->
        @if (!isFirstPage) {
          <li id="page-previous-{{ position }}-{{ idSuffix }}">
            <a
              href="#"
              [tabindex]="isFirstPage ? -1 : 0"
              [attr.aria-label]="labelVorherigeSeite"
              [title]="labelVorherigeSeite"
              (click)="pagePrevClicked($event)"
              >{{ aktuelleSeite - 1 }}</a
            >
          </li>
        }

        <li class="now-page-active" id="page-active-{{ position }}-{{ idSuffix }}" tabindex="-1">
          <span class="sr-only">Seite</span>
          <span aria-current="page">{{ aktuelleSeite }}</span>
          <span class="sr-only">von {{ anzahlSeiten() }}</span>
        </li>

        <!-- Seite NACH der "aktuellen Seite"-->
        <!-- Wird die letzte gewählt, wird diese Seite ausgeblendet -->
        @if (!isLastPage) {
          <li id="page-next-{{ position }}-{{ idSuffix }}">
            <a
              href="#"
              [attr.aria-label]="labelNaechsteSeite"
              [title]="labelNaechsteSeite"
              (click)="pageNextClicked($event)"
              >{{ aktuelleSeite + 1 }}</a
            >
          </li>
        }

        <!-- Drei Punkte vorwärts Button-->
        @if (isThreePagesNext) {
          <li class="now-page-next-group" id="page-next-three-{{ position }}-{{ idSuffix }}">
            <a
              href="#"
              [tabindex]="isFirstPage ? -1 : 0"
              aria-label="Drei Seiten vor"
              title="Drei Seiten vor"
              (click)="pageThreePagesNextClicked($event)"
              >...</a
            >
          </li>
        }

        <!-- Zur letzten Seite -->
        @if (!isSecondLastPage && !isLastPage) {
          <li id="page-last-number-{{ position }}-{{ idSuffix }}">
            <a
              href="#"
              [tabindex]="isLastPage ? -1 : 0"
              [attr.aria-label]="labelLetzteSeite"
              [title]="labelLetzteSeite"
              (click)="pageLastClicked($event)"
              >{{ anzahlSeiten() }}</a
            >
          </li>
        }

        <!-- Zur Nächsten Seite-->
        <li
          class="now-page-next"
          id="page-next-arrow-{{ position }}-{{ idSuffix }}"
          [class.disabled]="isLastPage"
          [attr.aria-disabled]="isLastPage"
        >
          <a
            href="#"
            [tabindex]="isLastPage ? -1 : 0"
            [attr.aria-label]="labelNaechsteSeite"
            [title]="labelNaechsteSeite"
            (click)="pageNextClicked($event)"
          >
          </a>
        </li>

        <!-- Zur Letzten Seite Mobile -->
        <!-- Die Letzte Seite wird nur ausgeblendet, wenn die letze Seite gewählt wurde -->
        <li
          class="now-page-last"
          id="page-last-{{ position }}-{{ idSuffix }}"
          [class.disabled]="isLastPage"
          [attr.aria-disabled]="isLastPage"
        >
          <a
            href="#"
            [tabindex]="isLastPage ? -1 : 0"
            [attr.aria-label]="labelLetzteSeite"
            [title]="labelLetzteSeite"
            (click)="pageLastClicked($event)"
          ></a>
        </li>
      </ul>
    </nav>
  }
</div>
